import React from "react";
import services from "../../services";
import UserListFilterComponent from "./user_list_filter_component";
import { withRouter } from "react-router-dom";
import TablePagination from "../common/TablePagination";
import TableHeader from "../common/table_header";
import DeleteModal from "../common/delete_modal";
import TitleBar from "../common/title_bar";
import SearchFilter from "../filters/SearchFilter";
import Main from "../../Pages/Demo/main";
import Lang from "../../lang";
import TlkTable from "../tlelrik/table/tlkTable";
var moment = require("moment");

const filters = {
    Tabs: {
        Utilizador: [
            {
                key: "Last Login Date",
                displayKey: "Search By Date",
                inputType: "RangePicker",
            },
            {
                key: "nome",
                displayKey: "Search By Name",
                inputType: "text",
            },
            {
                key: "email",
                displayKey: "Search By Email",
                inputType: "text",
            },
        ],
    },
    checkbox: [],
};

const format1 = "DD/MM/YYYY HH:mm:ss";

const columnkeyMap = {
    name: Lang.langCheck.langRequest("Name"),
    email: Lang.langCheck.langRequest("Email"),
    status: Lang.langCheck.langRequest("Status"),
    lastLoginDate: Lang.langCheck.langRequest("Last Login Date"),
};

class UserListComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            telkikTable: "",
            tlkState: null,
            totalcount: "0",
            SortBy: "ID",
            SortType: false,
            Paginate: true,
            Page: 1,
            PageSize: 100,
            Filters: null,
            filterData: [],
        };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount() {
        this.createpayload();
    }

    createpayload = () => {
        let data = {
            FiltersIn: this.state.Filters,
            SortBy: this.state.SortBy,
            IsSortTypeDESC: this.state.IsSortTypeDESC,
            IsPagination: this.state.Paginate,
            Page: this.state.Page,
            PageSize: this.state.PageSize,
        };
        this.getUserList(data);
        // console.log("state Filters .................",this.state.Filters);
    };
    getUserList = async (data) => {
        // console.log("daaaaatttaaa",data)
        let _user = await services.apiCall.requestApi(
            "User/GetFilteredList",
            data,
            "post"
        );

        console.log("useeeeeee", _user);

        if (_user) {
            _user.map((_row, index) =>
                Object.keys(columnkeyMap).map(function (key) {
                    _row[columnkeyMap[key]] = _row[key];
                    if (key === "lastLoginDate" && _row[key]) {
                        _row[columnkeyMap[key]] =
                            _row[key] === "0001-01-01T00:00:00"
                                ? "nd"
                                : services.Converter.dateConvert(
                                      _row[key],
                                      format1
                                  );
                    }
                })
            );
            this.setState(
                {
                    data: _user,
                    filterData: _user,
                    totalcount: window.localStorage.getItem("table_total"),
                },
                () => this.createTabel()
            );
        }
    };

    /*  Para obter a chave de filtros dos filtros personalizados para recuperar a API com base nisso */

    getFilters = (customfilters) => {
        console.log("custom ", customfilters);
        let Filters = {};
        // debugger;
        console.log("filterssss.........", customfilters);
        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters.nome
        )
            Filters["FullName"] = customfilters.filters.nome;

        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters.email
        )
            Filters["Email"] = customfilters.filters.email;

        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters["data final de login"]
        )
            Filters["enddate"] = customfilters.filters["data final de login"];

        if (
            customfilters &&
            customfilters.filters &&
            customfilters.filters["data inicial de login"]
        )
            Filters["startdate"] =
                customfilters.filters["data inicial de login"];

        this.setState({ Filters: Filters, telkikTable: null }, () =>
            this.createpayload()
        );
    };

    handleFilter = (data) => {
        this.setState(
            {
                telkikTable: null,
                filterData: data,
            },
            () => this.createTabel()
        );
    };

    /*  Para excluir uma linha da base de dados no servidor */

    handleDelete = async (row) => {
        let res = await services.apiCall.requestApi(
            `User/Delete/${row.id}`,
            "post"
        );
        if (res) {
            //console.log("res",res)
            this.createpayload();
        }
    };

    updatelistsort = (sort, key) => {
        this.setState(
            {
                SortBy: key,
                SortType: sort,
            },
            () => this.createpayload()
        );
    };
    updatelistpagenumsize = (PageSize, page_num) => {
        this.setState(
            {
                Page: page_num,
                PageSize: PageSize,
            },
            () => this.createpayload()
        );
    };

    columnlist = Object.keys(columnkeyMap).map(function (key) {
        return { field: columnkeyMap[key], columnMenuType: "checkbox" };
    });

    createTabel = () => {
        let actionbuttons = {
            Edit: true,
            Redirect: false,
            AdministrationDelete: "User",
        };
        //console.log("DATA",this.state.data);
        let telkikTable = (
            <TlkTable
                tlkState={this.state.tlkState}
                tableFilters={(filter) => this.tableFilters(filter)}
                date={new Date()}
                modulename={"userList"}
                deleteFunc={(id) => this.handleDelete(id)}
                list={this.state.filterData}
                actionbuttons={actionbuttons}
                columnlist={this.columnlist}
                ActionPerform={(action, id) => this.ActionPerform(action, id)}
            />
        );
        this.setState({
            telkikTable: telkikTable,
        });
    };

    tableFilters = (filter) => {
        if (JSON.stringify(this.state.tlkState) !== JSON.stringify(filter)) {
            let tlkState = { ...filter };
            console.log("filter", tlkState);
            let SortBy = "ID";
            let IsSortTypeDESC = false;
            let columnkeyMaprev = {};
            for (var key in columnkeyMap) {
                columnkeyMaprev[columnkeyMap[key]] = key;
            }
            if (filter && filter.sort && filter.sort.length > 0) {
                SortBy = columnkeyMaprev[filter.sort[0].field];
                IsSortTypeDESC = filter.sort[0].dir === "asc" ? false : true;
            }

            this.setState(
                {
                    Page: Math.ceil(filter.skip / filter.take) + 1,
                    PageSize: filter.take || 100,
                    SortBy,
                    IsSortTypeDESC,
                    tlkState,
                },
                () => {
                    this.createpayload();
                }
            );
        }
    };

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        if (action == "Edit") {
            this.props.history.push({
                pathname: "/create_user",
                search: "?id=" + encodeURIComponent(row.detalheURL),
                state: {
                    user_id: row.id,
                    topBarMenu: this.props.topBarMenuOption,
                },
            });
        }
    };

    render() {
        //console.log("hjdsdk",this.state.Filters)
        return (
            <div className="inner-container">
                <div className="outer-space">
                    <TitleBar
                        path={"/create_user"}
                        topBarMenu={this.props.topBarMenuOption}
                        title="Utilizadores"
                        logo="user"
                        noOption={true}
                    />
                    <SearchFilter
                        searchplaceholder="Selecione um critério de pesquisa junto aos filtros avançados"
                        showSearchDisabled={true}
                        filters={filters}
                        handleFilter={(data) => this.handleFilter(data)}
                        data={this.state.data}
                        getFilter={(data) => this.getFilters(data)}
                    />
                    <div className="table-responsive table-section">
                        <h3>
                            {" "}
                            A pesquisa retornou {this.state.totalcount}{" "}
                            resultados{" "}
                        </h3>
                        {this.state.telkikTable}
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(UserListComponent);
